// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountPayoutSettings --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountPayoutSettingsFragment on OpenapiAccountPayoutSettings {
    debit_negative_balances
    schedule {
      automatic
      delay_days
      interval
      monthly_anchor
      weekly_anchor
    }
    statement_descriptor
  }
`;

export const stripeAccountPayoutSettingsFragment: StripeAccountPayoutSettingsFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountPayoutSettingsFragmentData = {
  readonly __typename: 'OpenapiAccountPayoutSettings';
  readonly debit_negative_balances: boolean;
  readonly statement_descriptor: string | null;
  readonly schedule: {
    readonly __typename: 'OpenapiTransferSchedule';
    readonly automatic: boolean | null;
    readonly delay_days: number;
    readonly interval: string;
    readonly monthly_anchor: number | null;
    readonly weekly_anchor: string | null;
  };
};

export type StripeAccountPayoutSettingsFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountPayoutSettingsFragmentPermissions = {} as const;

doc.permissions = stripeAccountPayoutSettingsFragmentPermissions;

export type StripeAccountPayoutSettingsFragmentPermissions = V1PermissionToken<
  typeof stripeAccountPayoutSettingsFragmentPermissions
>;

export type StripeAccountPayoutSettingsFragmentDocument = GraphQlDocument<
  StripeAccountPayoutSettingsFragmentData,
  StripeAccountPayoutSettingsFragmentVariables,
  StripeAccountPayoutSettingsFragmentPermissions
>;
